<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visibleM = true"
          style="margin-right: 10px"
        >
          新增货币
        </a-button>
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visible = true"
        >
          新增汇率转化设置
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <template>
              <a-button type="link" size="small" @click="handleEdit(tableRow)">
                详情
              </a-button>
            </template>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visibleM"
      destroyOnClose
      @ok="handleSubmitM"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="货币名称">
          <a-input
            :maxLength="4"
            allowClear
            v-decorator="$decorator('name', '货币名称不能为空')"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="货币">
          <a-select v-decorator="$decorator('moneyId', '请选择货币')">
            <a-select-option v-for="item in moneyList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="货币金额">
          <a-input
            :maxLength="20"
            allowClear
            v-decorator="$decorator('usd', '货币金额不能为空')"
          ></a-input>
        </a-form-item>

        <a-form-item label="换算人民币">
          <a-input
            :maxLength="20"
            allowClear
            v-decorator="$decorator('rmb', '换算人民币不能为空')"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibleView"
      destroyOnClose
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="货币">
          <a-select
            :disabled="disabled"
            v-decorator="$decorator('moneyId', '请选择货币')"
          >
            <a-select-option v-for="item in moneyList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="货币金额">
          <a-input
            :maxLength="20"
            allowClear
            v-decorator="$decorator('usd', '金额不能为空')"
            :disabled="disabled"
          ></a-input>
        </a-form-item>

        <a-form-item label="换算人民币">
          <a-input
            :maxLength="20"
            allowClear
            v-decorator="$decorator('rmb', '换算人民币不能为空')"
            :disabled="disabled"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { addM, getMoneyList, add, getTableData } from './api'
export default {
  mixins: [mixin],
  data() {
    return {
      tableLoading: true,
      visible: false,
      visibleM: false,
      visibleView: false,
      modalForm: this.$form.createForm(this),
      modalTitle: '新增',
      //货币下拉选
      moneyList: [],
      disabled: false,
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    this._getTableData()
    //获取货币下拉选
    this._getMoneyList()
  },
  methods: {
    // 获取货币
    _getMoneyList() {
      getMoneyList().then(({ data }) => {
        this.moneyList = data
      })
    },

    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    // 货币提交和编辑
    handleSubmitM() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }
          try {
            const { message } = await addM({
              ...values,
              id: this.id,
            })
            this.visibleM = false

            this.$notification.success({
              message: '提示',
              description: message,
            })
            //重新获取货币下拉选
            this._getMoneyList()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 提交和编辑
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }

          try {
            const { message } = await add({
              ...values,
              id: this.id,
            })
            this.visible = false

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.id = ''
      this.modalTitle = '新增'
    },
    // 点击详情
    handleEdit({ rmb, moneyId, usd, id }) {
      this.visibleView = true
      this.disabled = true
      this.modalTitle = '详情'
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          rmb,
          moneyId,
          usd,
          id,
        })
        this.id = id
      }, 20)
    },
  },
}
</script>
